import styled from "styled-components";
import theme from "./theme";

const mainBlack    = theme.colors.mainBlack;
const mainWhite    = theme.colors.mainWhite;
const pointYellow  = theme.colors.pointYellow;
const darkGray     = theme.colors.darkGray;
const sideMenu     = theme.colors.sideMenu;
const lightGray02     = theme.colors.lightGray02;
const lightGray01     = theme.colors.lightGray01;
const middleGray02     = theme.colors.middleGray02;
const middleGray01     = theme.colors.middleGray01;
const opacity_40   = theme.colors.opacity_40;
const shadow_100   = theme.utility.shadow_100;
const shadow_200   = theme.utility.shadow_200;
const md           = theme.screens.md;
const lg           = theme.screens.lg;
// const scrollBack   = theme.colors.scrollBack;
// const scrollBar    = theme.colors.scrollBar;

export const SectionContainer = styled.div`
    display: flex;
    justify-content: center;
    width: 100%;
    max-width: 1440px;
    background-color: #FFF;
    /* min-height: calc(100vh - 70px); */
    min-height: 550px;
`;

// 해당 페이지 내용물 너비 잡아주는 div
export const SectionWidth = styled.div<{$width:number}>`
    max-width: ${props => props.$width}px;
    width: 100%;
`;

export const SectionTitleBox = styled.div`
    margin: 60px auto 0;
    line-height: 150%;
    text-align: center;
    color: #000;

    & h1 {
        font-size: 34px;
        font-weight: 600;
    }
    & h3 {
        margin-top: 20px;
        font-size: 16px;
        font-weight: 300;
        line-height: 23px;
    }
`;

export const SectionContent = styled.div`
    display: flex;
    justify-content: space-between;
    width: 860px;
    /* width: 100%; */
    max-width: 1080px;
    margin: 0 auto;

    & .section-sub-title-box {
        line-height: 150%;

        & h4 {
            font-size: 20px;
            font-weight: 600;
        }
        & h6 {
            padding-left: 11px;
            font-size: 14px;
            font-weight: 300;
        }

    }

    & .section-flex-box {
        display: flex;
        justify-content: center;
    }

    & .community-filter-button-box {
        display: flex;
        
        & button {
            margin-right: 10px;
            height: 31px;
            line-height: 31px;
            border: 0.5px solid ${middleGray02};
            border-radius: 16px;

            &:hover {
                background-color: ${mainBlack};
                color: #FFF;
            }
        }
    }
`;

export const SectionBorderContainer = styled.div`
    margin: 15px auto 0;
    padding: 0 20px;
    width: 550px;
    border: 0.5px solid ${middleGray02};
    border-radius: 5px;

    & .content-line {
        position: relative;
        display: flex;
        width: 100%;
        margin: 14px 0;
        font-size: 16px;

        & .label-box {
            width: 100px;
            min-width: 100px;
            font-weight: 600;
            color: ${darkGray};
        }

        & .content-box {
            font-weight: 300;
            color: ${mainBlack};
            
            /* 예약 내용 요약 문자 */
            & p {
                white-space: pre;
                max-height: 100px;
                overflow-y: hidden;
            }

            & .request-item {
                width: 410px;
                text-overflow: ellipsis;
                overflow: hidden;
                white-space: nowrap;
            }

            & .reservation-detail-request-item {
                white-space: pre-wrap;
            }
        }

        & .pay-button {
            margin-left: 10px;
            height: 16px;
            line-height: 16px;
            padding: 0 8px;
            border: 0.5px solid ${middleGray02};
            border-radius: 4px;
            color: ${middleGray02};
            font-size: 14px;

            &:hover {
                background-color: ${mainBlack};
                border-color: ${mainBlack};
                color: #FFF;
            }
        }
    }
`;

export const SearchBox = styled.div`
    position: relative;

    & input {
        width: 320px;
        height: 50px;
        border-radius: 25px;
        text-indent: 25px;
        border: 0.5px solid ${middleGray02};
        outline: none;

        &::placeholder {
            color: ${middleGray02};
            font-size: 14px;
            font-weight: 300;
        }
    }

    & .close-icon {
        position: absolute;
        top: 50%;
        right: 50px;
        line-height: 50px;
        transform: translateY(-50%);
        color: ${middleGray02};
        &:hover {
            cursor: pointer;
        }
    }

    & .search-icon {
        position: absolute;
        top: 50%;
        right: 15px;
        line-height: 50px;
        transform: translateY(-50%);
    }
`;

export const EmptyRoundedButton = styled.button<{$width?:number, $btnSelect:boolean}>`
    width: ${props => props.$width ? `${props.$width}px` : '100%'};
    height: 50px;
    margin: 0 5px;
    border-radius: 40px;
    border: 0.5px solid ${middleGray02};
    text-align: center;
    background-color: ${props => props.$btnSelect ? `${lightGray01}` : ``};
    color : ${mainBlack};
    /* transition: color 0.3s ease-in-out; */

    &:hover {
        background-color: ${props => props.$btnSelect ? `${lightGray01}` : `${sideMenu}`};
    }
`;

export const EmptyReleaseButton = styled.button<{$btnSelect:boolean}>`
    width: 100%;
    height: 35px;
    margin: 0 5px;
    border-radius: 20px;
    border: ${props => props.$btnSelect ? `` : `0.5px solid ${middleGray02};`};
    text-align: center;
    font-size: 14px;
    background-color: ${props => props.$btnSelect ? `${pointYellow}` : ``};
    color : ${props => props.$btnSelect ? `${mainBlack}` : `${middleGray01}`};
    font-weight : ${props => props.$btnSelect ? `600` : ``};
    box-shadow : ${props => props.$btnSelect ? `${shadow_100}` : ``};

    &:hover {
        color: ${mainBlack};
        font-weight: 600;
    }
`

export const BrandSelectBox = styled.div`
    padding-left: 16px;
    padding-right: 16px;
    height: 320px;
    display: grid;
    align-items: start;
    grid-template-columns: repeat(6, 1fr);
    grid-template-rows: 105px;
    /* border-top: 0.5px solid ${middleGray02};
    border-left: 0.5px solid ${middleGray02}; */
    overflow-y: scroll;
    position: relative;

    /* 스크롤바 */
    &::-webkit-scrollbar {
        width: 10px;
    }
    &::-webkit-scrollbar-thumb {
        height: 10%; /* 스크롤바의 길이 */
        background-color: ${lightGray01}; /* 스크롤바의 색상 */
        border-radius: 5px;

        &:hover {
            background-color: ${middleGray02};
        }
    }
    &::-webkit-scrollbar-track {
        border-radius: 5px;
        background-color: ${sideMenu};  /*스크롤바 뒷 배경 색상*/
    }
`;

export const BrandItemBox = styled.div<{$btnSelect:boolean}>`
        display: flex;
        justify-content: center;
        align-items: center;
        height: 105px;
        /* padding: 20px 0; */
        border-top: 0.5px solid ${middleGray02};
        border-left: 0.5px solid ${middleGray02};
        border-right: 0.5px solid ${middleGray02};
        border-bottom: 0.5px solid ${middleGray02};
        text-align: center;
        background-color: ${props => props.$btnSelect ? `${lightGray01}` : ""};

        & img {
            margin: auto;
        }
        & p {
            font-size: 14px;
            margin-top: 14px;
        }
        
        &:hover {
            cursor: pointer;
            background-color: ${props => props.$btnSelect ? `${lightGray01}` : `${lightGray02}`};
        }

        & .direct-box {
            transform: translateY(40%);
            padding: 0;
            margin: 0;
            font-size: 14px;
        }
`;

export const ProductContainer = styled.div`
    padding-left: 16px;
    padding-right: 16px;
    height: 250px;
    margin-bottom: 20px;
    overflow-y: scroll;
    position: relative;

    /* 스크롤바 */
    &::-webkit-scrollbar {
        width: 10px;
    }
    &::-webkit-scrollbar-thumb {
        height: 10%; /* 스크롤바의 길이 */
        background-color: ${lightGray01}; /* 스크롤바의 색상 */
        border-radius: 5px;

        &:hover {
            background-color: ${middleGray02};
        }
    }
    &::-webkit-scrollbar-track {
        border-radius: 5px;
        background-color: ${sideMenu};  /*스크롤바 뒷 배경 색상*/
    }

    & .empty-box {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        color: ${lightGray01};
    }
`;

export const ProductSelectBox = styled.div`
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    border-top: 0.5px solid ${middleGray02};
    border-left: 0.5px solid ${middleGray02};
    font-size: 14px;
`;

export const ProductTypeBox = styled.div`
    display: flex;
    justify-content: right;
    align-items: center;
    /* justify-content: center; */
    width: 100%;
    height: 10px;
    margin: 20px 20px;
    padding-right: 30px;
    font-size: 14px;

    & .product-type-flex {
        display: flex;

        & span {
            padding: 5px 10px;

            &:hover {
                cursor: pointer;
                color: ${mainBlack};
            }
        }
    }
`;

export const ProductTypeButton = styled.div<{$btnSelect:boolean}>`
    color : ${props => props.$btnSelect ? `${mainBlack}` : `${middleGray02}`};
    font-weight : ${props => props.$btnSelect ? 500 : ""};
`;

export const ProductItemBox = styled.div`
    position: relative;
    padding: 16px 0 14px 12px;
    border-right: 0.5px solid ${middleGray02};
    border-bottom: 0.5px solid ${middleGray02};
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 100%;

    &:hover {
        background-color: ${lightGray02};
        cursor: pointer;
    }
`;

export const InputBoxContainer = styled.div`
    /* display: flex;
    justify-content: center; */
    width: 100%;

    @media ${lg} {
        display: block;
    }

    & .input-flex-box {
        display: flex;
        align-items: flex-start;
        gap: 10px;
        
        & > div:not([class*="flex-shrink-0"]) {
            flex: 1;
        }
    }

    & input {
        height: 40px;
        margin-bottom: 10px;
        border: 0.5px solid ${middleGray02};
        border-radius: 5px;
        text-indent: 10px;
        outline: none;

        &::placeholder {
            font-size: 14px;
            font-weight: 300;
        }

        &[type="date"] {
            padding-right: 40px;
            position: relative;
            
            &::-webkit-calendar-picker-indicator {
                position: absolute;
                right: 8px;
                top: 50%;
                transform: translateY(-50%);
                cursor: pointer;
                opacity: 0.6;
                width: 20px;
                height: 20px;
                
                &:hover {
                    opacity: 1;
                }
            }
            
            &::-moz-calendar-picker-indicator {
                position: absolute;
                right: 8px;
                top: 50%;
                transform: translateY(-50%);
                cursor: pointer;
                opacity: 0.6;
                width: 20px;
                height: 20px;
                
                &:hover {
                    opacity: 1;
                }
            }
        }
    }

    & textarea {
        width: 100%;
        padding: 10px;
        border: 0.5px solid ${middleGray02};
        border-radius: 5px;
        resize: none;
        outline: none;

        &::placeholder {
            font-size: 14px;
            font-weight: 300;
        }
    }

    & span {
        padding: 12px;
        font-size: 12px;
        font-weight: 600;
    }

    & .vertical-line {
        height: inherit;
        position: relative;

        &::before {
            position: absolute;
            content: "";
            left: 0;
            top: 50%;
            transform: translateY(-50%);
            width: 1px;
            height: 132%;
            border-left: 0.5px solid ${mainBlack};
        }
    }
    /* & .vertical-line {
        height: inherit;
        position: relative;

        &::before {
            position: absolute;
            content: "";
            left: 0;
            top: 55%;
            transform: translateY(-50%);
            width: 0.5px;
            height: 75%;
            border-left: 0.5px solid ${middleGray02};
        }
    } */
`;

export const InputItemBox = styled.div<{$inputWidth?:number, $inputMinWidth?:number}>`
    position: relative;
    
    .input-flex-box & {
        flex: 1;
    }

    & .input-title-box {
        position: relative;
        display: flex;
        margin: 8px 0 6px;
        align-items: center;
    }

    & span {
        padding: 0;
    }

    & .alert-text {
        margin-left: 8px;
        color: ${theme.colors.red400};
    }

    & .alert-text-new-line {
        color: ${theme.colors.red400};
    }

    & label {
        font-size: 12px;
        font-weight: 600;
    }

    & input {
        width: ${props => props.$inputWidth ? `${props.$inputWidth}px` : '100%'};
        min-width: ${props => props.$inputMinWidth ? `${props.$inputMinWidth}px` : 'auto'};
    }

    & select {
        width: ${props => props.$inputWidth ? `${props.$inputWidth}px` : '100%'};
        height: 40px;
        outline: none;
        border: 0.5px solid ${middleGray02};
        border-radius: 8px;
        text-indent: 8px;

        & option:disabled {
            display: none;
        }
    }

    & .photo-box {
        display: grid;
        grid-template-columns: repeat(4, 1fr);

        & .photo-item {
            width: 117px;
            height: 100px;
            line-height: 100px;
            border-radius: 5px;
            border: 0.5px solid ${middleGray02};
            color: ${middleGray02};
            text-align: center;
            font-size: 20px;

            &:hover {
                cursor: pointer;
                color: ${mainBlack};
                font-size: 22px;
                background-color: ${lightGray02};
            }
        }

        & .prev-item {
            position: relative;
            width: 117px;
            height: 100px;
            line-height: 100px;
            border-radius: 5px;
            border: 0.5px solid ${middleGray02};
            color: ${middleGray02};
            text-align: center;
            font-size: 20px;
            overflow: hidden;

            &:hover > .prev-hover {
                cursor: pointer;
                display: block;
            }

            & .prev-img {
                width: 117px;
                height: 100px;
            }

            & .prev-hover {
                position: absolute;
                display: none;
                top: 0;
                left: 0;
                width: 117px;
                height: 100px;
                background-color: ${opacity_40};
                border-radius: 5px;
                color: white;
                /* text-align: center; */
                /* line-height: 20px; */
                font-size: 13px;
                font-weight: 600;
            }
        }

        & input[type="file"] {
            position: absolute;
            width: 0;
            height: 0;
            padding: 0;
            margin: -1px;
            overflow: hidden;
            clip: rect(0, 0, 0, 0);
            border: 0;
        }
    }

    & input[type="checkbox"] {
        position: absolute;
        top: 0.75px;
        left: 0;
        width: 13px;
        height: 13px;
        margin: 0;
    }

    & .certification-timer {
        position: absolute;
        top: 0;
        right: 10px;
        height: 40px;
        line-height: 40px;
        vertical-align: middle;
        font-size: 12px;
        color: red;
    }

    & textarea {
        font-size: 13px;
    }

    & .length-box {
        display: flex;
        justify-content: right;
        margin-right: 4px;
        margin-top: -18px;

        & span {
            font-weight: 300;
            color: ${middleGray02};
        }
    }
`;

export const PhotoBox = styled.div<{$gridColumn:number}>`
    display: grid;
    grid-template-columns: repeat(${props => props.$gridColumn}, 1fr);
    grid-gap: 10px;

    & .photo-item {
        /* width: 117px; */
        height: 100px;
        line-height: 100px;
        border-radius: 5px;
        border: 0.5px solid ${middleGray02};
        color: ${middleGray02};
        text-align: center;
        font-size: 20px;

        &:hover {
            cursor: pointer;
            color: ${mainBlack};
            font-size: 22px;
            background-color: ${lightGray02};
        }
    }

    & .prev-item {
        position: relative;
        /* width: 117px; */
        height: 100px;
        line-height: 100px;
        border-radius: 5px;
        border: 0.5px solid ${middleGray02};
        color: ${middleGray02};
        text-align: center;
        font-size: 20px;
        overflow: hidden;

        &:hover > .prev-hover {
            cursor: pointer;
            display: block;
        }

        & .prev-img {
            /* width: 117px; */
            width: 100%;
            height: 100px;
        }

        & .prev-hover {
            position: absolute;
            display: none;
            top: 0;
            left: 0;
            /* width: 117px; */
            width: 100%;
            height: 100px;
            background-color: rgba(0, 0, 0, 0.5);
            border-radius: 5px;
            color: white;
            /* text-align: center; */
            /* line-height: 20px; */
            font-size: 13px;
            font-weight: 600;
        }
    }

    & input[type="file"] {
        position: absolute;
        width: 0;
        height: 0;
        padding: 0;
        margin: -1px;
        overflow: hidden;
        clip: rect(0, 0, 0, 0);
        border: 0;
    }
`;

export const PriceDetailBox = styled.div`
    display: flex;
    justify-content: center;
    width: 100%;
    margin: 20px auto 30px;
    font-size: 14px;
    color: ${middleGray02};

    & .width-box {
        width: 500px;
    }
    
    & .price-detail-item-box {
        display: flex;
        justify-content: space-between;
    }
`;

export const ReservationSummary = styled.div`
    display: grid;
    position: relative;
    grid-template-columns: repeat(6, 1fr);
    margin: 0 auto;
    padding: 30px 0;
    width: 100%;
    border: 0.5px solid ${middleGray02};
    border-radius: 5px;
    background-color: #fff;

    @media ${md} {
        padding: 30px 0;
    }

    & .usage-items {
        text-align: center;
        position: relative;
        font-size: 14px;
        z-index: 1;

        &:hover {
            cursor: pointer;
        }

        &::before {
            content: "";
            position: absolute;
            left: 0;
            top: 50%;
            transform: translateY(-50%);
            width: 1px;
            height: 100%;
            border-right: 1px solid ${middleGray02};
        }

        &:nth-child(1)::before {
            border-right: 0;
        }

        & .usage-icon-box {
            display: flex;
            justify-content: center;
            margin-bottom: 12px;
        }

        & p {
            font-weight: 300;
            font-size: 18px;
            padding-bottom: 15px;
        }

        & span {
            font-weight: 600;
            font-size: 21px;
        }
    }
`;

export const ReservationTableHead = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 8px 0 6px;
    width: 100%;
    line-height: 150%;
    border-top: 1px solid ${mainBlack};
    border-bottom: 1px solid ${mainBlack};
    color: ${mainBlack};
    font-size: 14px;
    font-weight: 600;
    text-align: center;
    cursor: pointer;

    & .sortable-box {
        display: flex;
        justify-content: center;

        & span {
            position: relative;
            display: flex;

            & img {
                position: absolute;
                top: 4.5px;
                right: -15px;
                filter: invert(71%) sepia(9%) saturate(357%) hue-rotate(179deg) brightness(91%) contrast(89%);
                /* transition: 0.3s; */
            }
        }
    }

    & .flexible-hide-box {
        display: flex;
        justify-content: center;

        @media ${md} {
            display: none;
        }

        & span {
            position: relative;
            display: flex;

            & img {
                position: absolute;
                top: 4.5px;
                right: -15px;
                filter: invert(71%) sepia(9%) saturate(357%) hue-rotate(179deg) brightness(91%) contrast(89%);
                /* transition: 0.3s; */
            }
        }
    }
`;

export const ReservationTableBody = styled.div<{$withBtn:boolean}>`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 8px 0;
    width: 100%;
    border-bottom: 0.5px solid ${middleGray02};
    font-size: 14px;
    font-weight: 300;
    color: ${mainBlack};
    text-align: center;

    &:hover {
        background-color: ${sideMenu};
        cursor: ${props => props.$withBtn ? "" : "pointer"};
    }

    & .pay-status-box {
        height: 25px;
        line-height: 25px;
        border-radius: 12.5px;
        font-size: 12px;
        font-weight: 600;
    }

    & .request-box {
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
    }

    & .estimate-to-reservation-btn {
        height: 25px;
        line-height: 25px;
        border: 0.5px solid ${middleGray02};
        border-radius: 12.5px;
        color: ${mainBlack};
        font-size: 12px;
        font-weight: 600;

        &:hover {
            background-color: ${mainBlack};
            color: #FFF;
            cursor: pointer;
        }
    }
`;
export const ShoppingTableBody = styled.div<{$withBtn:boolean}>`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 8px 0;
    width: 100%;
    border-bottom: 0.5px solid ${middleGray02};
    font-size: 14px;
    font-weight: 300;
    color: ${mainBlack};
    text-align: center;

    &:hover {
        cursor: ${props => props.$withBtn ? "" : "pointer"};
    }

    & .pay-status-box {
        height: 25px;
        line-height: 25px;
        border-radius: 12.5px;
        font-size: 12px;
        font-weight: 600;
    }

    & .request-box {
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;

        & textarea {
            padding: 8px;
            font-weight: 300;
            line-height: 150%;
            &:hover{
                background-color: ${sideMenu};
            }

            &:focus {
                background-color: ${sideMenu};
            }
        }
    }

    & .estimate-management-button {
        height: 25px;
        line-height: 25px;
        margin: 10px 0;
        border-width: 0.5px;
        border-style: solid;
        border-radius: 12.5px;
        font-size: 12px;
        font-weight: 600;

        &:hover {
            opacity: 0.8;
        }
    }

    & .modify-btn {
        background-color: ${sideMenu};
        border-color: ${darkGray};

        &:hover {
            cursor: pointer;
        }
    }
    
    & .reservation-btn {
        background-color: ${mainBlack};
        border-color: ${mainBlack};
        color: #FFF;

        &:hover {
            cursor: pointer;
        }
    }
    
    & .delete-btn {
        background-color: ${mainWhite};
        border-color: ${middleGray02};
        color: ${middleGray01};

        &:hover {
            cursor: pointer;
        }
    }
`;

export const PaginationBox = styled.div`
    width: 100%;
    display: flex;
    justify-content: center;

    & .page-btn-box {
        display: flex;
        align-items: center;
        font-size: 16px;

        & div {
            display: flex;
            align-items: center;
            width: 20px;
            height: 20px;
            text-align: center;

            &:hover {
                color: ${mainBlack};
            }
        }
    }

    & img {
        filter: invert(71%) sepia(9%) saturate(357%) hue-rotate(179deg) brightness(91%) contrast(89%);
    }

    // TODO: 이것도 tailwind로 3항연산자로 config에 넣어서 세팅하자
    & button:hover img {
        filter: invert(0%) sepia(4%) saturate(0%) hue-rotate(292deg) brightness(101%) contrast(106%);
    }
`;

export const excelDownloadModalContent = styled.div`
    position: absolute;
    display: flex;
    justify-content: center;
    padding: 20px;
    top: 50%;
    left: 50%;
    width: 360px;
    background-color: white;
    box-shadow: ${shadow_200};
    transform: translate(-50%, -50%);

    & .inner-box {
        width: 100%;

        & .title {
            font-size: 16px;
            font-weight: 600;
        }

        & .option-controll-box {
            display: flex;
            justify-content: space-between;
        }

        & .button-box {
            display: flex;
            justify-content: end;
        }
    }
`;

export const ReservationModalBack = styled.div`
    position: fixed;
    overflow-y: hidden;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-color: ${opacity_40};
    z-index: 1299;
`;

export const ReservationModalContent = styled.div`
    position: absolute;
    display: flex;
    justify-content: center;
    padding: 30px 40px;
    top: 50%;
    left: 50%;
    width: 632px;
    max-height: 750px;
    transform: translate(-50%, -50%);
    border-radius: 10px;
    box-shadow: ${shadow_200};
    background-color: #fff;
    overflow: scroll;

    @media screen and (max-height : 750px) {
        padding: 25px 40px 15px;
        overflow-y: scroll;
    }

    & .content-title {
        position: relative;
        width: 100%;
        text-align: center;
        font-size: 21px;
        font-weight: 600;

        & button {
            position: absolute;
            right: 0;
            top: -3px;
        }

        & .close-icon {
            width: 24px;
            height: 24px;
            
            &:hover {
                filter: invert(71%) sepia(9%) saturate(357%) hue-rotate(179deg) brightness(91%) contrast(89%);
            }
        }
    }

    & .image-box {
        display: flex;
        justify-content: space-between;
        margin-top: 15px;
        padding-bottom: 20px;
        width: 100%;
        

        & img {
            width: 118px;
            height: 100px;
            border-radius: 5px;
        }
    }
`;

export const ReservationSelectOneContainer = styled.div`
    & .content-title {
        position: relative;
        width: 100%;
        text-align: center;
        font-size: 34px;
        font-weight: 600;
    }

    & .image-label-box {
        display: flex;
        justify-content: center;

        & .image-label {
            width: 550px;
            margin: 20px 0 8px;
            font-size: 16;
            font-weight: 600;
        }
    }

    & .image-box {
        display: flex;
        justify-content: center;
        column-gap: 10px;
        padding-bottom: 20px;
        width: 100%;
        background-color: white;
        overflow: hidden;
        
        & img {
            width: 130px;
            height: 90px;
            object-fit: cover;
            border-radius: 5px;
            opacity: 0.8;

            &:hover {
                cursor: pointer;
                opacity: 1;
            }
        }
    }
`;

export const ChargeChartBox = styled.div`
    display: flex;
    justify-content: space-between;
    width: 480px;
    margin: 50px auto 0;
    color: ${mainBlack};

    & .rows-box {
        width: 100%;

        & .charge-rows {
            line-height: 180%;
            display: flex;
            justify-content: space-between;

            & span {
                width: fit-content;
                white-space: nowrap;

                &.start {
                    width: 120px;
                    max-width: 120px;
                }
            }

            & .expand-dot {
                flex: 1 0 auto;
            }
        }
    }
`;

export const FAQCategoryBox = styled.div`
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    grid-column-gap: 10px;
    margin: 50px auto 0;
    width: 500px;
    color: ${middleGray02};
`;

export const FAQCategoryButton = styled.button<{$active:boolean}>`
    padding: 0 10px;
    height: 30px;
    background-color: ${props => props.$active && mainBlack};
    border-style: solid;
    border-width: ${props => props.$active ? '1px' : '0.5px'};
    border-color: ${props => props.$active ? mainBlack : middleGray02};
    border-radius: 15px;
    font-size: 14px;
    color: ${props => props.$active ? mainWhite : middleGray02};
    font-weight: ${props => props.$active ? 600 : 300};

    &:hover {
        border-color: ${mainBlack};
        color: ${props => props.$active ? mainWhite : mainBlack};
        font-weight: 600;
    }
`

export const communitySortButton = styled.div`
    padding: 0 10px;
    position: absolute;
    /* height: 31px;
    overflow-y: hidden; */
    border: 0.5px solid ${mainBlack};
    border-radius: 16px;
    background-color: #fff;

    &:hover {
        cursor: pointer;
    }

    & .appear-area {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 31px;
    }

    & .dis-appear-area {
        display: flex;
        justify-content: end;
        height: 24px;
        line-height: 24px;
        color: ${middleGray02};

        &:hover {
            color: ${mainBlack};
        }
    }
`;

export const CommunityDropdownBox = styled.div`
    position: relative;
    /* display: grid;
    grid-template-columns: repeat(2, 1fr); */
    padding: 8px 0;

    & .checkbox-undefined {
        display: flex;
        align-items: end;
        height: 30px;

        & input {
            margin-right: 8px;
            margin-bottom: 6px;
            height: 14px;
            accent-color: ${theme.colors.darkGray};
            cursor: pointer;
        }

        & label {
            color: ${theme.colors.mainBlack};
            font-size: 13px;
            cursor: pointer;
        }
    }
`;

export const FilterSquareMeterSlide = styled.div`
    position: relative;
    height: 4px;
    width: 100%;
    border-radius: 10px;
    background-color: ${theme.colors.lightGray02};
`;

export const FilterSquareMeterSlideInner = styled.div<{$rangeMinPercent: number, $rangeMaxPercent: number}>`
    position: absolute;
    left: ${props => props.$rangeMinPercent}%;
    right: ${props => props.$rangeMaxPercent}%;
    height: 4px;
    border-radius: 10px;
    background-color: ${theme.colors.middleGray02};
`;

export const FilterSquareMeterRangeWrap = styled.div`
    position: relative;
`;

export const FilterSquareMeterRangeMin = styled.input`
    position: absolute;
    /* top: -9px; */
    height: 7px;
    width: 100%;
    appearance: none;
    background: none;
    pointer-events: none;

    &::-webkit-slider-thumb {
        height: 20px;
        width: 20px;
        border-radius: 50%;
        border: 2px solid ${theme.colors.lightGray01};
        background-color: white;
        -webkit-appearance: none;
        pointer-events: auto;
        cursor: pointer;
    }
`;

export const FilterSquareMeterRangeMax = styled(FilterSquareMeterRangeMin)``;

export const SquareMeterIndicator = styled.div`
    padding-bottom: 8px;
    width: 100%;
    text-align: center;
    font-size: 12px;

    & .apply-button {
        height: 20px;
        line-height: 30px;
        font-size: 14px;
        cursor: pointer;
    }

    & .checkbox-undefined {
        display: flex;
        align-items: end;
        margin-top: 10px;

        & input {
            margin-right: 8px;
            margin-bottom: 6px;
            height: 14px;
            accent-color: ${theme.colors.darkGray};
            cursor: pointer;
        }

        & label {
            color: ${theme.colors.mainBlack};
            font-size: 13px;
            cursor: pointer;
        }
    }
`;

export const CommunityCategoryBox = styled.div`
    display: grid;
    grid-template-columns: repeat(8, 1fr);
`;

export const CommunityBrandButton = styled.button<{$btnSelect:boolean}>`
    padding: 8px 0;
    color: ${props => props.$btnSelect ? mainBlack : middleGray02};
    font-weight: ${props => props.$btnSelect ? 600 : 300};
    /* line-height: 150%; */
    font-size: 14px;

    &:hover {
        color: ${mainBlack};
        font-weight: 600;
    }
`;

export const PortfolioContainer = styled.div`
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    margin-top: 20px;
    grid-column-gap: 10px;
    grid-row-gap: 25px;
    place-items: center;
    /* width: 100%; */

    @media ${lg} {
        grid-template-columns: repeat(4, 1fr);
    }
    @media ${md} {
        grid-template-columns: repeat(3, 1fr);
    }
`;

export const PortfolioDropdownBackground = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: transparent;
    z-index: 1;
`;

export const PortfolioBox = styled.div`
    
    &:hover > .image-box > .thumbnail-img {
        /* transform: scale(1.15); */
        opacity: 1;
    }
    &:hover > .text-box > h3 {
        color: ${middleGray01};
    }

    & .image-box {
        position: relative;
        width: 208px;
        height: 150px;
        background-color: ${lightGray02};
        border-radius: 5px;
        overflow: hidden;

        & .thumbnail-img {
            width: 208px;
            height: 150px;
            border: 0;
            border-radius: 5px;
            object-fit: cover;
            opacity: 0.8;
            transition: all 0.4s ease-in-out;
        }

        & .favorite-icon {
            position: absolute;
            right: 8px;
            bottom: 8px;
            border-radius: 50%;
            
            &:hover {
                cursor: pointer;
                background-color: rgba(255, 255, 255, 0.4);
                opacity: 1;
            }

            & .favorite-img {
                /* margin-top: -2px; */
            }
        }
    }

    & .text-box {
        & h3 {
            margin-top: 10px;
            width: 200px;
            height: 36px;
            line-height: 130%;
            font-size: 14px;
            font-weight: 600;
            text-transform: uppercase;
            text-overflow: ellipsis;
            overflow: hidden;
            /* white-space: nowrap; */
            display: -webkit-box;
            -webkit-line-clamp: 2; 
            -webkit-box-orient: vertical;
        }
    
        & span {
            line-height: 150%;
            font-size: 12px;
            font-weight: 300;
            color: ${middleGray01};
        }
    }

`;

export const PostPortfolioContainer = styled.div`
    width: 550px;
    font-size: 14px;

    & .select-box {
        position: relative;

        & .prev-construct-search-box {
            position: absolute;
            display: flex;
            justify-content: center;
            align-items: center;
            left: 0;
            top: 50px;
            width: 100%;
            height: 60px;
            z-index: 2002;
                & .prev-construct-search-input {
                    padding-left: 8px;
                    width: 520px;
                    height: 40px;
                    outline: none;
                    font-size: 16px;
                    box-shadow: rgba(0, 0, 0, 0.12) 0px 1px 3px, rgba(0, 0, 0, 0.24) 0px 1px 2px;
                }

                & .prev-construct-search-icon {
                    position: absolute;
                    right: 25px;
                    filter: invert(71%) sepia(9%) saturate(357%) hue-rotate(179deg) brightness(91%) contrast(89%);
                }
        }

        & .product-search-box {
            position: absolute;
            display: flex;
            justify-content: center;
            align-items: center;
            left: 0;
            top: 200px;
            width: 100%;
            height: 60px;
            z-index: 2002;

            & .product-search-input {
                padding-left: 8px;
                width: 520px;
                height: 40px;
                outline: none;
                font-size: 16px;
                box-shadow: rgba(0, 0, 0, 0.12) 0px 1px 3px, rgba(0, 0, 0, 0.24) 0px 1px 2px;
            }

            & .product-search-icon {
                position: absolute;
                right: 25px;
                filter: invert(71%) sepia(9%) saturate(357%) hue-rotate(179deg) brightness(91%) contrast(89%);
            }
        }
    }

`;

export const DropdowMenuButton = styled.div<{$activeButton: boolean}>`
    position: absolute;
    width: 550px;
    /* height: 40px; */
    line-height: 40px;
    background-color: #FFF;
    border: 0.5px solid ${middleGray02};
    border-radius: 5px;
    max-height: 305px;
    overflow-y: scroll;
    box-shadow: ${props => props.$activeButton && `${sideMenu}`};
    cursor: pointer;

    &:hover {
        background-color: ${sideMenu};
    }

    & span {
        margin-left: 17px;
        padding-right: 40px;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
    }

    & img {
        position: absolute;
        right: 15px;
        top: 14px;
        transition: 0.4s transform;
        transform: ${props => props.$activeButton ? `rotate(270deg)` : `rotate(90deg)`};
    }
`;

export const DropdownHideMenu = styled.div`
    padding: 5px;
    position: absolute;
    width: 100%;
    max-height: 300px;
    border-radius: 5px;
    /* border-top-width: 0; */
    background-color: #FFF;
    box-shadow: rgba(0, 0, 0, 0.25) 0px 2px 8px;
    z-index: 2000;
    overflow-y: scroll;

    & p {
        padding: 0 17px 0 17px;
        height: 40px;
        line-height: 40px;
        border-radius: 5px;
        color: ${middleGray02};
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
        cursor: pointer;

        &:hover {
            background-color: ${sideMenu};
            color: ${mainBlack};
        }
    }
`;

export const CommunityReviewBox = styled.div`
    position: relative;
    /* margin-top: 200px; */
    width: 550px;
    outline: 0.5px solid ${middleGray02};
    border-radius: 5px;
    
    & textarea {
        padding: 17px;
        width: 100%;
        resize: none;
        outline: none;
    }

    & .length-box {
        display: flex;
        justify-content: right;
        margin-right: 5px;
        margin-top: -20px;

        & span {
            font-size: 12px;
            font-weight: 300;
            color: ${middleGray02};
        }
    }
`;

export const PaymentInformationFlexBox = styled.div`
    display: flex;
    justify-content: space-between;
    padding: 20px 0;
    line-height: 150%;

    & .left-side {

        & .logo-box {
            position: relative;
            margin-left: 15px;
            width: 80px;
            height: 80px;
            border: 0.5px solid ${middleGray02};

            & img {
                position: absolute;
                width: 50px;
                height: 50px;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
            }
        }

        & .product-info {
            margin-left: 15px;
            padding-top: 5px;
            color: ${darkGray};
            font-size: 16px;
            font-weight: 300;
        }
    }

    & .right-side {
        position: relative;
        min-width: 100px;
        color: #181818;
        font-size: 16px;
        font-weight: 600;

        & .total-point {
            position: absolute;
            right: 0;
            bottom: 0;
        }
    }

    & .client-info {
        margin-left: 15px;
        line-height: 150%;
        color: ${mainBlack};
        font-size: 16px;

        & p {
            font-weight: 300;
        }

        & h5 {
            font-weight: 600;
        }
    }

    & .payment-left {
        font-weight: 300;
    }

    & .payment-right {
        font-weight: 600;
        text-align: right;

        & input {
            padding-right: 4px;
            width: 100px;
            border: 0.5px solid ${middleGray02};
            border-radius: 2px;
            text-align: right;
            outline: none;
        }
    }
`;

export const EmptyContentBox = styled.div`
    width: 100%;
    height: 180px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: ${middleGray02};
    font-size: 14px;
`;

export const CommunityImageContainer = styled.div`

    & .big-image-box {
        position: relative;
        display: flex;
        justify-content: center;
        width: 100%;
        height: 300px;
        border-radius: 5px;
        transition: all 0.4s;
        /* transition-delay: 0.4s; */
        
        & img {
            width: 100%;
            height: 300px;
            border-radius: 5px;
            object-fit: cover;
            transition: all 0.6s;
        }

        &:hover {
            height: 400px;
        }

        &:hover > img {
            height: 400px;
            object-fit: contain;
            transition-delay: 0.2s;
        }

        &:hover + .image-list-box {
            height: 0;
            margin-top: 0;
        }

        &:hover > button {
            opacity: 0.4;
            transition-delay: all 0.4s;
            transition-delay: color 0;
        }

        & button {
            position: absolute;
            top: 50%;
            height: 25px;
            line-height: 25px;
            padding: 0 5px;
            color: #FFF;
            background-color: ${mainBlack};
            border: 1px solid ${mainBlack};
            border-radius: 5px;
            font-weight: 600;
            transform: translateY(-50%);
            opacity: 0;
            transition: all 0.4s;
            transition: color 0;

            /* &:hover {
                opacity: 1;
            } */
        }

        & :first-child {
            left: 20px;
        }

        & :last-child {
            right: 20px;
        }
    }

    & .image-list-box {
        display: flex;
        justify-content: center;
        align-items: center;
        column-gap: 10px;
        /* display: grid;
        grid-template-columns: repeat(4, 1fr);
        justify-content: center; */
        margin-top: 10px;
        height: 90px;
        overflow: hidden;
        transition: all 0.4s;

        & .individaul-box {
            /* width: 135px;
            height: 90px; */

            & img {
                border-radius: 5px;
                width: 130px;
                height: 90px;
                object-fit: cover;
                border: 2px solid #FFF;
                opacity: 0.8;

                &:hover {
                    border-color: ${pointYellow};
                    opacity: 1;
                    cursor: pointer;
                }
            }
        }
    }
`;

export const SelectOnePortfolioContainer = styled.div`
    
`;

export const SelectOnePortfolioTitleBox = styled.div`
    display: flex;
    justify-content: space-between;

    & .text-box {

        & h3 {
            font-size: 24px;
            font-weight: 500;
            line-height: 34px;
        }

        & span {
            font-weight: 300;
            line-height: 150%;
        }
    }

    & .icon-box {
        padding-top: 5px;
        padding-right: 5px;
        
        & img {
            cursor: pointer;
        }
    }
`;

export const SelectOnePortfolioImageBox = styled.div`

    & .big-image-box {
        cursor: pointer;
        
        & img {
            width: 550px;
            height: 305px;
            object-fit: contain;
        }
    }

    & .image-list-box {
        display: flex;
        justify-content: left;
        align-items: center;
        column-gap: 10px;
        /* display: grid;
        grid-template-columns: repeat(4, 1fr);
        justify-content: center; */
        margin-top: 10px;
        overflow: hidden;
        transition: all 0.4s;

        & .individaul-box {
            /* width: 135px;
            height: 90px; */

            & img {
                width: 130px;
                height: 87px;
                object-fit: cover;
                opacity: 0.8;

                &:hover {
                    opacity: 1;
                    cursor: pointer;
                }
            }
        }
    }
`;

export const SelectOnePortfolioContentBox = styled.div`
    margin-top: 90px;
    margin-bottom: 40px;
    border-top: 1px solid ${darkGray};
    border-bottom: 1px solid ${darkGray};
    
    & .content-line {
        display: flex;
        height: 40px;
        line-height: 40px;
        border-color: ${middleGray02};
        border-style: solid;
        font-size: 14px;

        & .label-box {
            padding-left: 20px;
            width: 90px;
            color: ${darkGray};
        }

        & .content-box {
            color: ${mainBlack};
            font-weight: 600;
        }
    }
`;

export const SelectOnePortfolioModal = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.9);
    z-index: 3000;

    & .flex-box {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 4.5%;

        & .modal-image-box {
            /* position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%); */
            height: 600px;
    
            & img {
                height: 600px;
            }
        }
    
        & .arrow-box {
            position: absolute;
            display: flex;
            justify-content: center;
    
            & img {
                filter: invert(53%) sepia(6%) saturate(227%) hue-rotate(182deg) brightness(91%) contrast(90%);
                cursor: pointer;
    
                &:hover {
                    filter: invert(100%) sepia(100%) saturate(0%) hue-rotate(94deg) brightness(106%) contrast(101%);
                }
            }
        }
    }


    & .close-box {
        position: absolute;
        top: 12%;

        & img {
            filter: invert(53%) sepia(6%) saturate(227%) hue-rotate(182deg) brightness(91%) contrast(90%);
            cursor: pointer;

            &:hover {
                filter: invert(100%) sepia(100%) saturate(0%) hue-rotate(94deg) brightness(106%) contrast(101%);
            }
        }
    }

    & .index-box {
        margin-top: 5%;
        color: white;
        text-align: center;
    }
`;